import React, { useState } from "react";
import { EasyBefore, m12 } from "../../constant/Index";
import "../../assets/Css/Style.css";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import "../../assets/Css/Profile.css";
import ProfileTab from "./ProfileTab";
import { useGetApplyLoanQuery } from "../../store/services/ApplyloanServices";
import { useSiteSettingUrlQuery } from "../../store/services/SiteSettingServices";
import Spinner from "../../utils/Loader";

const LoanApplicaitonInterests = () => {
	let [statuss, setStatus] = useState("");
	const { data, isFetching } = useGetApplyLoanQuery();
	const { data: ImageUrl, isFetching: ImageLoad } = useSiteSettingUrlQuery();
	console.log(data, "23232");
	// if (data?.response?.data?.status === "pending") {
	// 	setStatus("Pending");
	// } else if (data?.response?.data?.status === "rejected") {
	// 	setStatus("Rejected");
	// } else {
	// 	setStatus("Accpeted");
	// }

	let navigate = useNavigate();

	return (
		<>
			{!isFetching ? (
				<>
					<div className="services Account">
						{/* Header */}
						<Header />
						{/* Header */}

						{/* Easy Plan Sec Start Here */}
						<section className="easy-plan mt-5">
							<div className="right-before">
								<figure>
									<img src={EasyBefore} alt="" className="img-fluid" />
								</figure>
							</div>
							<div className="container mt-5">
								<div className="row mb-3">
									<div className="col-lg-12 text-left">
										<p>
											Home{" "}
											<span className="fa fa-chevron-right chevron_right">
												{" "}
											</span>{" "}
											Profile
										</p>
									</div>
								</div>
							</div>
						</section>

						{/* accout section starts*/}
						<section className="profile_section">
							<div className="overflow_me_profile">
								<div className="container">
									<div className="row">
										<div className="col-lg-3">
											<ProfileTab />
										</div>
										<div className="col-lg-9">
											<div className="InfoDetails">
												<h3 className="heading_Account">
													My Loan Application Status
												</h3>
												<div className="InnerDivScrol">
													<div className="row">
														{data?.response?.data?.map((item, index) => {
															return (
																<>
																	<div className="col-lg-7  my-0 my-lg-2">
																		<div className="d-flex">
																			<img
																				className="product_img mr-4"
																				src={`${ImageUrl?.uploads}${item?.vehicle?.image}`}
																				alt="product"
																			/>
																			<div>
																				<h4 className="subheading_Account">
																					{item?.vehicle?.title}
																				</h4>
																				<p>{item?.vehicle?.description}</p>
																			</div>
																		</div>
																	</div>
																	<div className="col-lg-5 my-0 my-lg-2">
																		<div className="white_switch">
																			<p className="loan_status">
																				Loan Status:{" "}
																			</p>
																			<p
																				className={`${
																					item?.status
																						?.charAt(0)
																						?.toUpperCase() +
																					item?.status?.slice(1)
																				}`}
																			>
																				{item?.status
																					?.charAt(0)
																					?.toUpperCase() +
																					item?.status?.slice(1)}
																			</p>
																		</div>
																	</div>
																</>
															);
														})}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
						{/* accout section ends*/}
						{/* Footer */}
						<Footer />
						{/* Footer */}
					</div>
				</>
			) : (
				<Spinner />
			)}
		</>
	);
};

export default LoanApplicaitonInterests;
